import { StyleSheet } from '@react-pdf/renderer'

export const colors = {
  bg: 'white',
  activityReportHeaderBg: '#3786A2',
  documentHeaderBg: '#229C82',
  documentHeader: 'white',
  documentHeaderSecondary: '#444444',
  documentSubHeaderBg: '#2ECFAD',
  activityReportSubHeaderBg: '#4FC0E8',
  documentSubHeader: 'white',
  sectionOddBg: '#FFFFFF',
  sectionOddSecondaryBg: '#E6E6E6',
  sectionEvenBg: '#E6E6E6',
  sectionEvenSecondaryBg: '#F6F6F6',
  bold: '#444444',
  text: '#6E6E6E',
  error: '#EE4B2B',
  link: '#4FC0E8',
  field: '#F6F6F6',
  fieldSecondary: '#FFFFFF',
}

export const spacing = (value: number = 1) => value * 8

export const padding = (value: number = 1) => value * spacing(0.5)

export const fontSize = {
  pageTitle: 16,
  pageSubtitle: 12,
  pageDetails: 8,
  text: 10,
}

/**
 * Width of a single space character for most font families for
 * a given fontSize.
 */
export const spaceWidth = Object.assign(
  Object.fromEntries(
    Object.entries(fontSize).map(([key, fontSize]) => [
      key,
      getSpaceWidth(fontSize),
    ]),
  ) as {
    [K in keyof typeof fontSize]: number extends typeof fontSize[K]
      ? number
      : never
  },
  {
    custom: getSpaceWidth,
  },
)

function getSpaceWidth(fontSize: number): number {
  return fontSize * 0.25
}

export const fontFamily = 'Roboto'
export const fontFamilyArabic = 'RobotoArabic'

export const styles = StyleSheet.create({
  title: {
    textTransform: 'uppercase',
    fontWeight: 'bold',
    fontSize: fontSize.text,
  },
  subtitle: {
    fontSize: fontSize.text,
    textTransform: 'capitalize',
    fontWeight: 'bold',
    color: colors.documentHeaderSecondary,
  },
  text: {
    fontSize: fontSize.text,
    color: colors.text,
  },
  bold: {
    fontSize: fontSize.text,
    color: colors.bold,
    fontWeight: 'bold',
  },
  textSecondary: {
    fontSize: fontSize.pageDetails,
    color: colors.text,
    fontWeight: 'light',
  },
  errorText: {
    fontSize: fontSize.pageDetails,
    color: colors.error,
    fontWeight: 'bold',
  },
})
